import { Typography, styled } from '@mui/material';

export const PageText = styled(Typography)(({ theme }) => ({
  fontSize: '1rem',
  fontWeight: 400,
  lineHeight: '1.5rem',
  color: theme.palette.primary.main,
}));
